@if (visible) {
    <div class="fixed bg-white top-0 left-0 w-full h-full flex flex-col">
        <div class="flex flex-row gap-4 justify-between items-center p-2">
            <div class="truncate">
                {{ filename }}
            </div>
            <div class="flex flex-row gap-4">
                <a [href]="fileUrl" target="_blank" class="flex flex-row items-center gap-2">
                    <mat-icon>cloud_download</mat-icon>
                    Stáhnout...
                </a>
                <mat-icon (click)="closePdfViewer()">close</mat-icon>
            </div>
        </div>
        <ngx-extended-pdf-viewer
            [src]="fileUrl"
            [showOpenFileButton]="false"
            [showDownloadButton]="false"
            [showPrintButton]="false"
            [showPresentationModeButton]="false"
            [showFindButton]="false"
            [showSecondaryToolbarButton]="false"
            [showBookModeButton]="false"
            [showHighlightEditor]="false"
            [showStampEditor]="false"
            [showDrawEditor]="false"
            [showTextEditor]="false"
            [showFindHighlightAll]="false"
            [showRotateButton]="false"
            [showSidebarButton]="false"
            [height]="'100%'">
        </ngx-extended-pdf-viewer>
    </div>
}
